import { z } from "zod";

const totpCode = z.string().regex(/^\d{6}$/);
const email = z
  .email()
  .max(254)
  .transform((e) => e.toLowerCase());

export const loginInput = z.object({
  email,
  password: z.string().min(1).max(200),
  turnstileToken: z.string().min(1).max(2048),
});
export const mfaInput = z.object({ code: totpCode });
/** Reautenticação para (re)configurar o MFA: senha sempre; código atual quando o MFA já está ativo (SEG5). */
export const mfaSetupInput = z.object({ password: z.string().min(1).max(200), code: totpCode.optional() });

export const createTenantInput = z.object({
  tenantName: z.string().trim().min(2).max(120),
  slug: z.string().regex(/^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/, "Use letras minúsculas, números e hífen"),
  adminEmail: email,
  adminName: z.string().trim().min(2).max(120),
  password: z.string().min(12, "Mínimo de 12 caracteres").max(200),
  companyLegalName: z.string().trim().min(2).max(200),
});

/** Primeiro acesso (decisão da Fabi, 08/10/2026): cria a primeira conta pela tela de login, sem token. */
export const setupInput = z.object({
  companyName: z.string().trim().min(2, "Informe o nome da empresa").max(120),
  name: z.string().trim().min(2, "Informe seu nome").max(120),
  email,
  password: z.string().min(12, "A senha precisa ter 12 caracteres ou mais").max(200),
  turnstileToken: z.string().min(1).max(2048),
});

/** Encerramento de conta (T3.11, rota do operador): e-mail que recebe o link dos dados e quem pediu. */
export const offboardTenantInput = z.object({
  notifyEmail: email,
  operator: z
    .string()
    .trim()
    .min(2)
    .max(120)
    // eslint-disable-next-line no-control-regex -- texto livre sem controles (vai para log e para o D1)
    .regex(/^[^\u0000-\u001f\u007f]+$/, "Sem caracteres de controle"),
});
/** Tenant das rotas `/admin/tenants/{tenantId}/...` (ULID). */
export const adminTenantParam = z.object({ tenantId: z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/) });

export type LoginInput = z.input<typeof loginInput>;
export type CreateTenantInput = z.output<typeof createTenantInput>;
export type CompanySummary = { id: string; legalName: string; tradeName: string | null };
export type MeOutput = {
  user: { id: string; email: string; name: string; mfaEnabled: boolean };
  tenant: { id: string; slug: string; name: string };
  /** Só as empresas que o usuário pode acessar (memberships.allowed_company_ids). */
  companies: CompanySummary[];
  permissions: Record<string, string[]>;
};
/** GET /api/v1/config (público, rota da Task 4). O SPA não depende de VITE_* por ambiente (decisão 9). */
export type ConfigOutput = { env: string; turnstileSiteKey: string; turnstileAction: string };
